module.exports = __webpack_public_path__ + "media/images/home/river-4710a89feebc44badc1cf6e0e46fe697.png";